/**
 * 个人中心 -》 修改密码
 */


'use strict';
import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { dispatch } from '../../dispatcher/Dispatcher';

import { getItem as getLang } from '../../common/lang';
import ajax, { ajaxDispatch } from '../../common/utils/ajax';
import FormControl from '../../components/FormControl/FormControl.jsx';
import TextInput from '../../components/TextInput/TextInput.jsx';
import Button from '../../components/Button/Button.jsx';
import ErrorBox from '../../components/Alert/ErrorBox.jsx';
import Header from '../../components/Header/Header.jsx';
import Form from '../../components/Form/Form.jsx';
import UserStore from '../../stores/UserStore';
import UserDataUtils from '../../data-utils/UserDataUtils';

const changePwdControls = [
  {
    type: 'tel',
    id: 'mobile',
    name: 'mobile',
    label: getLang('MOBILE'),
    minLength: 11,
    maxLength: 11,
    required: true,
    tips: getLang('MOBILE_TIP')
  },
  {
    type: 'tel',
    id: 'captcha',
    name: 'captcha',
    label: getLang('CAPTCHA'),
    minLength: 6,
    maxLength: 6,
    required: true,
    tips: getLang('REQUIRED')
  },
  {
    type: 'password',
    id: 'newPwd',
    name: 'newPwd',
    label: getLang('NEW_PWD'),
    tips: getLang('AT_LEAST_6'),
    required: true,
    minLength: 6
  },
  {
    type: 'password',
    id: 'repeatPwd',
    name: 'repeatPwd',
    label: getLang('REPEAT_PWD'),
    tips: getLang('SAME_PWD'),
    required: true,
    minLength: 6
  }
];

const submitButton = {
  text: getLang('CHANGE_PWD')
};

export default class ChangePwd extends Component {

  constructor(props) {
    super(props);
    this.state = {
      captchaTimer: 0,
      accountType: 'phone'
    };
    //console.log(localStorage.companyCode);

    this.getCaptcha = this.getCaptcha.bind(this);
    this.validateMobile = this.validateMobile.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validateNext = this.validateNext.bind(this);
    this.chooseAccountType = this.chooseAccountType.bind(this);
    this.commit = this.commit.bind(this);
  }

  render() {
    const { captchaTimer } = this.state,
      getCaptchaText = captchaTimer ? `${captchaTimer} ${getLang('RETRY_CAPTCHA')}` : getLang('GET_CAPTCHA'),
      captchaDisabled = !!captchaTimer;
    //console.log(captchaDisabled);
    //console.log(captchaTimer);
    //console.log(captchaTimer);
    return (
      <div>
        <Header back title={getLang('CHANGE_PWD')} />
        <div className='login-forgot-page'>
          <form ref='changePasswordForm' className='login-forgot-form'>
            <div className='form-control form-control-radio' >
              <input type="radio" ref='accountTypePhone' name='accountType' defaultChecked={true} onChange={this.chooseAccountType} value='phone' />手机 <input type="radio" ref='accountTypeEmail' name='accountType' onChange={this.chooseAccountType} value='email' />邮箱
          </div>
            <FormControl label={getLang('MOBILE')} tips={getLang('REQUIRED')} type={this.state.accountType == 'phone' ? 'block' : 'hidden'}>
              <TextInput ref='phone' id='phone' name='phone'
                type='tel' required
                onChange={this.validateMobile} onBlur={this.validateMobile} />
            </FormControl>
            <FormControl label={getLang('EMAIL')} tips={getLang('REQUIRED')} type={'hidden'} type={this.state.accountType == 'email' ? 'block' : 'hidden'}>
              <TextInput ref='email' id='email' name='email'
                type='email' required
                onChange={this.validateMobile} onBlur={this.validateEmail} />
            </FormControl>
            <FormControl label={getLang('CAPTCHA')} tips={getLang('REQUIRED')}>
              <TextInput id='captcha' name='captcha' required onChange={this.validateNext} />
            </FormControl>
            <Button ref='getCaptcha'
              className='login-get-captcha' text={getCaptchaText} link
              style={{ bottom: 'auto', top: '7.75rem' }}
              onTouchTap={captchaDisabled?function(){}:this.getCaptcha} />

            <FormControl label={getLang('NEW_PWD')} tips={getLang('AT_LEAST_6')}>
              <TextInput type='password' id='newPwd' name='newPwd' minLength="6" required />
            </FormControl>
            <FormControl label={getLang('REPEAT_PWD')} tips={getLang('SAME_PWD')}>
              <TextInput type='password' id='repeatPwd' name='repeatPwd' minLength="6" required />
            </FormControl>
            <ErrorBox ref='errorBox' />
            <input type='hidden' ref='accountType' id='type' name='type' />
            <Button ref='next' className='login-reset-pwd' text={getLang('CHANGE_PWD')} disabled onTouchTap={this.commit} />
          </form>
        </div>
      </div>
    );
  }

  /**
 * choose account type (phone or email)
 * 
 * @memberof event
 */
  chooseAccountType(e) {
    if (e.target.value == 'phone') {
      React.findDOMNode(this.refs.accountTypePhone).checked = 'checked';
      React.findDOMNode(this.refs.email).value = '1@1.com'; //test
      this.setState({ accountType: 'phone' });
    } else {
      var email = React.findDOMNode(this.refs.accountTypeEmail);
      email.checked = 'checked';
      React.findDOMNode(this.refs.phone).value = '15800000000'; //test
      this.setState({ accountType: 'email' });
    }
  }

  /**
   *  验证邮箱
   */
  validateEmail() {
    const item = React.findDOMNode(this.refs.email).value;
    let matchEmail = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})$/;
    let emailValid = matchEmail.test(item);

    if (item == '') {
      this.refs.errorBox.setState({ message: '邮箱格式有误' });
      return false;
    }
    if (!emailValid) {
      this.refs.errorBox.setState({ message: '邮箱格式有误' });
      return false;
    }
    this.refs.errorBox.setState({ message: '' });
    return true;
  }

  /**
  * 验证手机号
  */

  validateMobile() {
    const item = React.findDOMNode(this.refs.phone).value;

    let mobileValid = true;
    let emailValid = true;
    //check mobile
    if (item.length < 11) {
      mobileValid = false;
    }

    if (!mobileValid) {
      this.refs.errorBox.setState({ message: '手机号格式有误' });
      return false;
    }
    this.refs.errorBox.setState({ message: '' });
    return true;
  }

  /**
   * 获取验证码
   * 
  / */
  getCaptcha() {
    if (this.state.accountType == 'phone') {
      if (this.validateMobile() == false) {
        return;
      }
    } else {
      if (this.validateEmail() == false) {
        return;
      }
    }

    let timer = 61,
      timeout,
      self = this;

    function countDown() {
      timer -= 1;

      self.setState({
        captchaTimer: timer
      });

      if (timer === 0) {
        return clearTimeout(timeout);
      }

      timeout = setTimeout(countDown, 1000);
    }

    setTimeout(countDown, 0);
    let accountType = this.state.accountType,
      email = React.findDOMNode(this.refs.email).value,
      phone = React.findDOMNode(this.refs.phone).value,
      companyCode = localStorage.companyCode;

    if (this.state.accountType == 'phone') {
      if (this.validateMobile()) {
        ajax.post('/validation-no', {
          type: 1,
          companyCode: companyCode,
          phone: phone,
          captcha: ''
        })
          .then((res) => {
            //alert(JSON.stringify(res));
            if (res.res == false) {
              alert(res.error);
              dispatch({
                type: 'get-captcha-fail'
              });
              this.setState({captchaTimer: 0});
            } else {
              dispatch({ type: 'get-captcha-success' });
            }
          })
          .catch(() => {
            //alert('ex');
            clearTimeout(timeout);
            dispatch({
              type: 'get-captcha-fail'
            });
            this.setState({captchaTimer: 0});
          });
      }
    } else {
      if (this.validateEmail()) {
        ajax.post('/validation-email', {
          type: 2,
          companyCode: companyCode,
          email: email,
          captcha: ''
        })
          .then((res) => {
            if (res.res == false) {
              alert(res.error);
              dispatch({
                type: 'get-captcha-fail'
              });
              this.setState({captchaTimer: 0});
            } else {
              dispatch({ type: 'get-captcha-success' });
            }
          })
          .catch((e) => {
            clearTimeout(timeout);
            dispatch({
              type: 'get-captcha-fail'
            });
            this.setState({captchaTimer: 0});
          });
      }
    }
  }



  /**
   * Check if can go to next step
   * @param e
   */
  validateNext(e) {
    const captcha = e.target.value,
      valid = (this.validateMobile() && captcha && captcha.length);

    React.findDOMNode(this.refs.next).disabled = !valid;

    return valid;
  }

  /**
   * 
   *  修改密码表单提交
   */
  commit() {
    if (this.state.accountType == 'phone') {
      if (this.validateMobile() == false) {
        return;
      }
    } else {
      if (this.validateEmail() == false) {
        return;
      }
    }
    if (document.getElementById('captcha').value == '') {
      alert('Captcha is required');
      return false;
    }
    if (document.getElementById('newPwd').value == '') {
      alert(getLang('NEW_PWD') + ' ' + getLang('AT_LEAST_6'));
      return false;
    }
    if (document.getElementById('newPwd').value !== document.getElementById('repeatPwd').value) {
      alert(getLang('REPEAT_PWD') + ' ' + getLang('SAME_PWD'));
      return false;
    }

    React.findDOMNode(this.refs.accountType).value = (this.state.accountType == 'phone' ? 1 : 2);

    var form = React.findDOMNode(this.refs.changePasswordForm);
    const formData = new FormData(form);
    //formData.append('type',)
    // .afterSubmit(res)
    ajax.post('/change-password', formData)
      .then((res) => {
        if (res.res == false) {
          alert(res.error);
        } else {
          this.setState({
            disabled: false,
            submitting: false
          });

          alert(getLang('EDIT_SUCCESS'));
          history.back();
        }
      })
      .catch((e) => {
        this.setState({
          disabled: false,
          submitting: false
        });
      });

  }
}


// WEBPACK FOOTER //
// ./src/containers/Config/ChangePwd.jsx